import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as auth_actions from 'data/auth/actions';

import Field from 'components/Form/Field';
import Row from 'components/Form/Row';
import RaisedButton from 'material-ui/RaisedButton';

class ResetForm extends Component {

  state = {
    email:''    
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({email: this.refs.email.state.value })
    this.props.actions.reset(this.refs.email.state.value);
  }
  onSubmit = (e) => {
    e.preventDefault();
  }

  render () {
    return (
      <form autoComplete="off" className="login_form" onSubmit={this.onSubmit} action="#">
        <Field ref="email" value={this.state.email} floatingLabelText="E-postadress"/>
        <Row>
          <RaisedButton onTouchTap={this.handleSubmit} disabled={this.props.waiting} primary={true} labelColor="#fff" label="Återställ lösenord" />
        </Row>
        <Row>
          <span className="padded">
            {this.props.children}
          </span>
        </Row>
      </form>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    waiting: state.auth.waiting
  };
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...auth_actions }, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(ResetForm)

  



// WEBPACK FOOTER //
// ./src/components/Auth/ResetForm.jsx